/**
 * Initiales d'un nom pour un monogramme (avatar Halo) : première lettre du
 * premier et du dernier mot, en capitales. Une seule règle pour toute la
 * régie : compte, contacts, équipe, artistes.
 */
export function initialesDuNom(nom: string | null | undefined): string {
  const mots = (nom ?? '')
    .split(/[\s\-–—]+/u)
    .map((mot) => mot.replace(/^[^\p{L}]+/u, ''))
    .filter((mot) => mot.length > 0);
  if (mots.length === 0) return '';
  const premier = Array.from(mots[0]!)[0]!;
  const dernier = mots.length > 1 ? Array.from(mots[mots.length - 1]!)[0]! : '';
  return (premier + dernier).toLocaleUpperCase('fr');
}
